import { useState, useEffect } from "react";
import {
  Typography,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TextField,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import Button from "../../../../../componentsv2/Button";

import { useSnackbar } from "notistack";
import { api } from "../../../../../services/Api";
import useUser from "../../../../../hooks/useUser";
import DataPickerAtualizado from "../../../../../components/DataPickerAtualizado";
import {
  extrairMensagemErroCriacaoLote,
  montarPayloadLote,
  salvarProtocoloELote,
} from "../../utils/lote";

const ModalConfirmaLote = ({
  open,
  handleClose,
  convenio,
  nomeConvenio,
  valorSoftlab,
  valorDoLote,
  setValorDoLote,
  getTotalSoftlab,
  lote,
  dataInicial,
  dataFinal,
  mesCompetencia,
  anoCompetencia,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  // const [mesCompetencia, setMesCompetencia] = useState("");
  // const [anoCompetencia, setAnoCompetencia] = useState("");
  const [protocolo, setProtocolo] = useState("");
  const [previsao, setPrevisao] = useState(null);
  const [tipo, setTipo] = useState("NORMAL");
  const [loadingSalvarLote, setLoadingSalvarLote] = useState(false);

  const usuario = useUser();

  const salvarLote = async () => {
    if (loadingSalvarLote) {
      return;
    }

    const payloadLote = montarPayloadLote({
      dataInicial,
      dataFinal,
      codigo: lote,
      plano: convenio,
      protocolo,
      mesCompetencia,
      anoCompetencia,
      previsao,
      valor: valorDoLote,
      valorAlterado: valorSoftlab,
      emConstrucao: false,
      usuarioResponsavel: usuario,
      tipo,
    });

    try {
      setLoadingSalvarLote(true);
      await salvarProtocoloELote({
        payloadLote,
        apiClient: api,
      });
      enqueueSnackbar("Lote criado com sucesso.", {
        variant: "success",
      });
      getTotalSoftlab();
      handleClose(false);
      limparDados();
    } catch (error) {
      enqueueSnackbar(extrairMensagemErroCriacaoLote(error), {
        variant: "error",
      });
    } finally {
      setLoadingSalvarLote(false);
    }
  };

  const handleValorDoLote = (e) => {
    const valorLimpo = e.target.value.replace(/\D/g, "");

    if (!valorLimpo) {
      setValorDoLote("");
      return;
    }

    const valorNumerico = parseFloat(valorLimpo) / 100;

    if (
      valorSoftlab !== null &&
      valorSoftlab !== undefined &&
      valorNumerico > valorSoftlab
    ) {
      setValorDoLote(valorSoftlab);
      enqueueSnackbar(
        `O valor não pode ser maior que ${valorSoftlab?.toLocaleString(
          "pt-BR",
          {
            style: "currency",
            currency: "BRL",
          }
        )}`,
        {
          variant: "warning",
        }
      );
    } else {
      setValorDoLote(valorNumerico);
    }
  };

  const limparDados = () => {
    setProtocolo("");
    setPrevisao(null);
    setValorDoLote("");
    setTipo("NORMAL");
  };

  useEffect(() => {
    if (valorSoftlab) {
      setValorDoLote(valorSoftlab);
    }
  }, [setValorDoLote, valorSoftlab]);

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={open}
      onClose={handleClose}
      scroll="paper"
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
    >
      <DialogTitle
        id="scroll-dialog-title"
        sx={{ justifyContent: "space-between" }}
      >
        <Grid container justifyContent="space-between">
          <Grid item>
            <Typography variant="h6">Salvar Lote</Typography>
          </Grid>
          <Grid item>
            <IconButton onClick={() => handleClose(false)}>
              <Close />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>

      <DialogContent dividers sx={{ padding: "24px" }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600, mb: 2, color: "primary.main" }}
            >
              Informações Básicas
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  id="lote"
                  label="Lote"
                  value={lote}
                  disabled
                  fullWidth
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  id="protocolo"
                  label="Protocolo"
                  value={protocolo}
                  onChange={(e) => setProtocolo(e.target.value)}
                  fullWidth
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="convenio"
                  label="Convênio"
                  value={nomeConvenio || convenio}
                  disabled
                  fullWidth
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  id="tipo"
                  label="Tipo"
                  select
                  value={tipo}
                  onChange={event => setTipo(event.target.value)}
                  fullWidth
                  required
                  variant="outlined"
                >
                  <MenuItem value="NORMAL">Normal</MenuItem>
                  <MenuItem value="INTERNO">Interno</MenuItem>
                  <MenuItem value="PENDENCIA">Pendência</MenuItem>
                  <MenuItem value="NEGOCIACAO">Negociação</MenuItem>
                </TextField>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600, mb: 2, color: "primary.main" }}
            >
              Competência
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={6} sm={3}>
                <TextField
                  id="mesCompetencia"
                  label="Mês"
                  placeholder="MM"
                  value={mesCompetencia}
                  disabled
                  // onChange={(e) => setMesCompetencia(e.target.value)}
                  inputProps={{ maxLength: 2, inputMode: "numeric" }}
                  fullWidth
                  variant="outlined"
                  required
                />
              </Grid>
              <Grid item xs={6} sm={3}>
                <TextField
                  id="anoCompetencia"
                  label="Ano"
                  placeholder="AAAA"
                  value={anoCompetencia}
                  disabled
                  // onChange={(e) => setAnoCompetencia(e.target.value)}
                  inputProps={{ maxLength: 4, inputMode: "numeric" }}
                  fullWidth
                  variant="outlined"
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DataPickerAtualizado
                  data={previsao}
                  setData={setPrevisao}
                  labelName="Data de Previsão"
                  fullWidth
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600, mb: 2, color: "primary.main" }}
            >
              Valores
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  id="valorSoftlab"
                  label="Valor Softlab"
                  value={valorSoftlab?.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                  })}
                  disabled
                  fullWidth
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  id="valorDoLote"
                  label="Valor do Lote"
                  placeholder="R$ 0,00"
                  value={valorDoLote?.toLocaleString("pt-BR", {
                    style: "currency",
                    currency: "BRL",
                    minimumFractionDigits: 2,
                  })}
                  onChange={(e) => handleValorDoLote(e)}
                  inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                  fullWidth
                  variant="outlined"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions
        sx={{
          padding: "20px 24px",
          backgroundColor: "#f8f9fa",
          borderTop: "1px solid #e0e0e0",
        }}
      >
        <Grid container justifyContent="flex-end" spacing={2}>
          <Grid item>
            <Button
              color="gray"
              variant="outlined"
              onClick={() => {
                handleClose(false);
                limparDados();
              }}
              sx={{ minWidth: "120px" }}
            >
              Cancelar
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="green"
              onClick={() => salvarLote()}
              disabled={loadingSalvarLote}
              startIcon={loadingSalvarLote ? <CircularProgress size={16} color="inherit" /> : null}
              sx={{ minWidth: "120px" }}
            >
              {loadingSalvarLote ? "Salvando..." : "Salvar Lote"}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default ModalConfirmaLote;
